import { useNavigate } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useEffect, useState } from "react";
import withLoader from "./../../components/layouts/WithLoader";
import { Alert } from "@material-ui/lab";
import { Snackbar, TextField } from "@material-ui/core";

const ColisLivraison = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const animatedComponents = makeAnimated();
  const [userRole, setUserRole] = useState("");
  //alert
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState("");
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState("");
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const navigateToPageAdd = () => {
    navigate(`/ajouter-colis-livraison`);
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div class="card-body">
              <h5 class="card-title">Ajouter colis</h5>
              <button
                class="btn btn-dark  float-right"
                onClick={navigateToPageAdd}
              >
                {" "}
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(ColisLivraison);
